import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Fade,
  Nav,
  NavItem,
  NavLink,
  Spinner,
  TabContent,
  TabPane,
} from "reactstrap";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import ConfirmModal from "../../../components/comman/ConfirmModal";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import MainHeading from "../../../components/comman/MainHeading";
import PaginationComponent from "../../../components/comman/PaginationComponent";
import DeleteIcon from "../../../components/Icons/DeleteIcon";
import EditIcon from "../../../components/Icons/EditIcon";
import NoRecordIcon from "../../../components/Icons/NoRecordIcon";
import ViewIcon from "../../../components/Icons/ViewIcon";
import { updateFiltersStates } from "../../../store/actions/UserActions";
import { formatAmount } from "../../../utility/CommonFunctions";

export default function MyReimbursementForm() {
  const [isFirstYearChange, setIsFirstYearChange] = useState(true);
  const [model, setModel] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { id } = useParams();
  const [selected, setSelectedId] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const userDetails = useSelector((state) => state.root.userDetails);
  const filterDetails = useSelector((state) => state.root.filtersStates);
  const dispatch = useDispatch();
  const [pageStates, setPageStates] = useState({
    ActiveTab: "1",
    tableLoader: false,
    searchQuery: "",
    transactionData: [],
    countsData: {},
    companyList: [],
    userId: "",
    siteList: [],
  });
  const toggle = () => setModel(!model);

  useEffect(() => {
    if (filterDetails?.year) {
      GetReimbursementData();
    }
  }, [
    filterDetails?.currentPage,
    pageStates?.searchQuery,
    filterDetails?.pageSize,
    filterDetails?.sortByDate,
    filterDetails?.year,
    pageStates?.userId,
    id,
    pageStates?.ActiveTab,
  ]);

  const GetReimbursementData = () => {
    let options = {
      method: "GET",
    };
    const filterData = {
      ...filterDetails,
      searchQuery: pageStates?.searchQuery,
    };
    const Url =
      pageStates?.ActiveTab == 1
        ? apiUrl.get_transaction +
        `?from=reimbursementTicket&userId=${id ? id : userDetails?.id}&` +
        MainFilterHandler(filterData)
        : apiUrl.get_transaction +
        `?from=reimbursementForm&userId=${id ? id : userDetails?.id}&` +
        MainFilterHandler(filterData);
    setPageStates((pre) => ({
      ...pre,
      tableLoader: !pre.tableLoader,
    }));
    callApi(Url, options).then((res) => {
      setPageStates((pre) => ({
        ...pre,
        tableLoader: !pre.tableLoader,
      }));
      if (res?.status === true) {
        setPageStates((pre) => ({
          ...pre,
          transactionData: res?.data?.transaction,
          countsData: { ...res?.data?.counts },
        }));
        dispatch(
          updateFiltersStates({
            count: res?.data?.pageInfo?.total,
            totalPages: res?.data?.pageInfo?.totalPages,
          })
        );
      }
    });
  };

  const toggleTab = (tab) => {
    setPageStates((prev) => ({
      ...prev,
      ActiveTab: tab,
    }));
    dispatch(
      updateFiltersStates({
        currentPage: 1,
        pageSize: 10,
      })
    );
  };

  const PageChangeHandler = (PageNo) => {
    if (PageNo > 0 && PageNo <= filterDetails?.totalPages) {
      dispatch(
        updateFiltersStates({
          currentPage: PageNo,
        })
      );
    }
  };

  const handleChangePageSize = (value) => {
    dispatch(
      updateFiltersStates({
        currentPage: 1,
        pageSize: value,
      })
    );
  };

  const dateChangeHandler = (Dates) => {
    let formattedDate = null;
    if (Dates && Dates.length === 2) {
      const startDate = new Date(
        Dates[0].getTime() - Dates[0].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      const endDate = new Date(
        Dates[1].getTime() - Dates[1].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      formattedDate = [startDate, endDate];
    }
    if (formattedDate !== null) {
      dispatch(
        updateFiltersStates({
          sortByDate: formattedDate,
        })
      );
    } else {
      dispatch(
        updateFiltersStates({
          sortByDate: "",
        })
      );
    }
  };
  const handleYearChange = (selectedYear) => {
    dispatch(
      updateFiltersStates({
        year: selectedYear,
        sortByDate: isFirstYearChange ? filterDetails.sortByDate : [],
      })
    );

    if (isFirstYearChange) {
      setIsFirstYearChange(false);
    }
  };

  const HandleDelete = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl.delete_reimbursement + `?reimbursementFormId=${selected}`;
    setIsLoading(true);
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        toast.success(response?.message);
        toggle();
        GetReimbursementData();
      } else {
        toast.error(response?.message);
        toggle();
      }
    });
  };

  return (
    <>
      <div className="content">
        <MainHeading
          title={`${id ? location?.state?.name + "'s" : "My"
            } Reimbursement Form`}
          showBackButton={id ? true : false}
          dateChangeHandler={dateChangeHandler}
          showDefaultDate={true}
          handleYearChange={handleYearChange}
          buttonText={id ? null : "Create Reimbursement Form"}
          buttonLink={id ? null : RoutesLink.create_Reimbursement_Form}
        />
        <div className="card mb-4">
          <div className="card-body">
            <div className="d-flex align-items-center justify-content-between mb-4">
              <h2 className="card-title d-flex align-items-center gap-3">
                <span className="d-flex align-items-center justify-content-center p-3 rounded-circle bg-white border border-dark">
                  <svg
                    width="24"
                    height="24"
                    x="0"
                    y="0"
                    viewBox="0 0 466.415 466.415"
                    className=""
                  >
                    <g>
                      <path
                        d="M464.8 309.008c-3.1-4.6-9.2-5.8-13.8-2.7l-74.6 48.9h-98.2v-41h101.2c2.1 0 4.2-.8 5.8-2l77-55.6c4.5-3.2 5.5-9.5 2.2-13.9-3.2-4.5-9.5-5.5-13.9-2.2l-74.3 53.7h-98v-42h101.2c2.2.1 4.4-.6 6.2-1.9l77-60.7c4.3-3.5 5-9.8 1.6-14.1s-9.6-5-14-1.7l-74.3 58.4h-97.7v-40h101.2c2.5-.1 5-1.1 6.8-2.8l77-71.4c3-2.9 4-7.3 2.5-11.2-1.5-3.9-5.2-6.5-9.3-6.6H361c-.1 0-.3-1.8-.6-2.6-1.5-3.8-5.2-6.4-9.3-6.4h-153c-2.5 0-5 1-6.8 2.7l-6.7 6.3H87c-2.5.1-5 1.1-6.8 2.9l-77 71.3c-3 2.9-4 7.3-2.5 11.2 1.5 3.9 5.2 6.5 9.3 6.6h95.2v40H10c-5.5 0-10 4.5-10 10s4.5 10 10 10h95.2v42H10c-5.5 0-10 4.5-10 10s4.5 10 10 10h95.2v41H10c-5.5 0-10 4.5-10 10s4.5 10 10 10h369.4c2-.1 3.9-.7 5.5-1.9l77-50.4c4.6-3 5.9-9.3 2.9-13.9zm-118.9-188.8h85l-55.4 52h-85.1l55.1-51.6c.1 0 .2-.4.4-.4zm-237.9 52H35.5l55.4-52h72.2l-54.6 51.2c-.2.1-.3-.2-.5.8zm150.2 6.5v176.5h-133v-172.1l68.5-63.9 8.3-8h123.7l-64.3 59.9c-2.1 2-3.2 4.7-3.2 7.6z"
                        fill="#000000"
                        opacity="1"
                        data-original="#000000"
                        className=""
                      ></path>
                      <path
                        d="M233.8 231.308h-13.5c-1.1-5-3.1-9.7-5.8-14h19.3c5.6-.1 10.1-4.6 10.1-10.1s-4.5-10-10-10h-78.4c-5.5 0-10 4.5-10 10s4.5 10 10 10H178c9.5 0 17.6 5 21.4 14h-43.9c-5.5 0-10 4.5-10 10s4.5 10 10 10h43.9c-1.3 2.3-2.9 4.5-4.7 6.4-4.5 4.4-10.5 6.7-16.8 6.6h-22.5c-5.6.1-10.1 4.6-10 10.2 0 2.7 1.2 5.3 3.1 7.2l56.1 53.1c4 3.8 10.3 3.7 14.1-.3 3.8-4 3.7-10.3-.3-14.1l-.1-.1-37.9-35.8c10.6-.5 20.7-5 28.3-12.5 5.6-5.8 9.6-12.9 11.6-20.6h13.5c5.5 0 10-4.5 10-10s-4.5-10-10-10z"
                        fill="#000000"
                        opacity="1"
                        data-original="#000000"
                        className=""
                      ></path>
                    </g>
                  </svg>
                </span>
                Entries
              </h2>
              <div className="d-flex gap-3  align-items-center justify-content-between text-center">
                <p
                  className={
                    pageStates?.countsData?.netAmount === 0
                      ? "text-warning mb-0 fw-semibold"
                      : pageStates?.countsData?.netAmount > 0
                        ? "text-success mb-0 fw-semibold"
                        : "text-danger mb-0 fw-semibold"
                  }
                >
                  <span className="text-muted">Net Amount : </span>
                  {formatAmount(pageStates?.countsData?.netAmount || 0)}
                </p>
              </div>
            </div>
            <div className="d-flex gap-3 mb-3 align-items-center justify-content-between text-center">
              <div className="d-flex align-items-center bg-body-secondary p-3 w-100 justify-content-center">
                <h4 className="m-0">
                  {pageStates?.countsData?.totalEntries} Entries
                </h4>
              </div>
              <div className="d-flex align-items-center bg-body-secondary p-3 w-100 justify-content-center">
                <h4 className="m-0 text-success">
                  {formatAmount(pageStates?.countsData?.creditAmount || 0)}{" "}
                </h4>
              </div>
              <div className="d-flex align-items-center bg-body-secondary p-3 w-100 justify-content-center">
                <h4 className="m-0 text-danger">
                  {formatAmount(pageStates?.countsData?.debitAmount || 0)}
                </h4>
              </div>
            </div>

            <Nav tabs className="nav nav-tabs border-0 mb-4 w-100">
              <NavItem className="nav-item w-50">
                <NavLink
                  className={
                    pageStates?.ActiveTab === "1"
                      ? "btn btn-secondary border border-1 rounded-end-0 w-100 rounded-start-2 text-decoration-none text-success fw-bold"
                      : "btn btn-outline-secondary border border-1 rounded-end-0 w-100 rounded-start-2 text-decoration-none text-success"
                  }
                  style={{ cursor: "pointer" }}
                  onClick={() => toggleTab("1")}
                >
                  Credit Entries
                </NavLink>
              </NavItem>

              <NavItem className="nav-item w-50">
                <NavLink
                  className={
                    pageStates?.ActiveTab === "2"
                      ? "btn btn-secondary border border-1 rounded-start-0 w-100 rounded-end-2 text-decoration-none text-danger fw-bold"
                      : "btn btn-outline-secondary border border-1 rounded-start-0 w-100 rounded-end-2 text-decoration-none text-danger"
                  }
                  style={{ cursor: "pointer" }}
                  onClick={() => toggleTab("2")}
                >
                  Debit Entries
                </NavLink>
              </NavItem>
            </Nav>

            <TabContent activeTab={pageStates?.ActiveTab}>
              <TabPane tabId={"1"}>
                <Fade in={pageStates?.ActiveTab === "1"} timeout={200}>
                  <div className="row gap-3 m-0">
                    {pageStates?.tableLoader ? (
                      <div className="d-flex justify-content-center my-5 ">
                        <Spinner />
                      </div>
                    ) : pageStates?.transactionData?.length > 0 ? (
                      pageStates?.transactionData
                        ?.slice()
                        .reverse()
                        ?.map((item, index) => {
                          const isOlderThan48Hours =
                            moment().diff(
                              moment(item?.transactionDate),
                              "hours"
                            ) >= 48;
                          const isOlderThan12Hours =
                            moment().diff(
                              moment(item?.transactionDate),
                              "hours"
                            ) >= 12;

                          return (
                            <>
                              {!item?.isOpeningBalance && (
                                <div
                                  key={index}
                                  className="ledger col-12 row d-flex m-0 align-items-strech"
                                >
                                  {/* Date */}
                                  <span className=" col-12 col-md-2 text-center border-end">
                                    <span className="border d-flex justify-content-center gap-1 align-items-center mx-5 bg-body-secondary rounded fw-medium">
                                      {moment(item?.transactionDate).date()}
                                      <p className="fs-5 m-0 text-center">
                                        {moment(item?.transactionDate).format(
                                          "MMM"
                                        )}
                                      </p>
                                    </span>
                                  </span>
                                  {/* Transaction Info */}
                                  <div className=" col-12 col-md-6 border-end text-center">
                                    <p className="fs-4 m-0 text-center text-muted mb-0">
                                      Site - {item?.site?.name}
                                    </p>
                                  </div>
                                  {/* Amount */}
                                  <div className=" col-12 col-md-2 text-center border-end">
                                    <h4 className="text-success mb-0">
                                      {formatAmount(item?.amount || "--")}
                                    </h4>
                                  </div>
                                  {/* Action Buttons */}{" "}
                                  <div className=" col-12 col-md-2">
                                    <div className=" d-flex gap-2 justify-content-center">
                                      <button
                                        className="btn btn-sm btn-outline-primary px-3"
                                        onClick={() => {
                                          navigate(
                                            `${RoutesLink.payment_tickets_details}/reimbursement/${item?.paymentticket?.id}`
                                          );
                                        }}
                                      >
                                        <ViewIcon />
                                      </button>
                                      {!id && (
                                        <>
                                          <button
                                            className="btn btn-sm btn-outline-warning px-3"
                                            onClick={() =>
                                              navigate(
                                                RoutesLink.create_Reimbursement_Form,
                                                { state: item }
                                              )
                                            }
                                            disabled={isOlderThan48Hours}
                                          >
                                            <EditIcon />
                                          </button>
                                          <button
                                            className="btn btn-sm btn-outline-danger px-3"
                                            onClick={() => {
                                              setSelectedId(
                                                item?.reimbursementForm?.id
                                              );
                                              toggle(item);
                                            }}
                                            disabled={isOlderThan12Hours}
                                          >
                                            <DeleteIcon />
                                          </button>
                                        </>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              )}
                            </>
                          );
                        })
                    ) : (
                      <div className="d-flex flex-column justify-content-center align-items-center no-data-error">
                        <NoRecordIcon />
                        {"No record found"}
                      </div>
                    )}
                  </div>
                </Fade>
              </TabPane>
              <TabPane tabId={"2"}>
                <Fade in={pageStates?.ActiveTab === "2"} timeout={200}>
                  <div className="row gap-3 m-0">
                    {pageStates?.tableLoader ? (
                      <div className="d-flex justify-content-center my-5 ">
                        <Spinner />
                      </div>
                    ) : pageStates?.transactionData?.length > 0 ? (
                      pageStates?.transactionData
                        ?.slice()
                        .reverse()
                        ?.map((item, index) => {
                          const isOlderThan48Hours =
                            moment().diff(
                              moment(item?.transactionDate),
                              "hours"
                            ) >= 48;
                          const isOlderThan12Hours =
                            moment().diff(
                              moment(item?.transactionDate),
                              "hours"
                            ) >= 12;

                          return (
                            <>
                              {!item?.isOpeningBalance && (
                                <div
                                  key={index}
                                  className="ledger col-12 row d-flex m-0 align-items-strech"
                                >
                                  {/* Date */}
                                  <span className=" col-12 col-md-2 text-center border-end">
                                    <span className="border d-flex justify-content-center gap-1 align-items-center mx-5 bg-body-secondary rounded fw-medium">
                                      {moment(item?.transactionDate).date()}
                                      <p className="fs-5 m-0 text-center">
                                        {moment(item?.transactionDate).format(
                                          "MMM"
                                        )}
                                      </p>
                                    </span>
                                  </span>
                                  {/* Transaction Info */}
                                  <div className=" col-12 col-md-6 border-end text-center">
                                    <p className="fs-4 m-0 text-center text-muted mb-0">
                                      Site - {item?.site?.name}
                                    </p>
                                  </div>
                                  {/* Amount */}
                                  <div className=" col-12 col-md-2 text-center border-end">
                                    <h4 className="text-danger mb-0">
                                      {formatAmount(item?.amount || "--")}
                                    </h4>
                                  </div>
                                  {/* Action Buttons */}{" "}
                                  <div className=" col-12 col-md-2">
                                    <div className=" d-flex gap-2 justify-content-center">
                                      <button
                                        className="btn btn-sm btn-outline-primary px-3"
                                        onClick={() => {
                                          navigate(
                                            `${RoutesLink.reimbursement_details}/${item?.reimbursementForm?.id}`
                                          );
                                        }}
                                      >
                                        <ViewIcon />
                                      </button>
                                      {!id && (
                                        <>
                                          <button
                                            className="btn btn-sm btn-outline-warning px-3"
                                            onClick={() =>
                                              navigate(
                                                RoutesLink.create_Reimbursement_Form,
                                                { state: item }
                                              )
                                            }
                                          // disabled={isOlderThan48Hours}
                                          >
                                            <EditIcon />
                                          </button>
                                          <button
                                            className="btn btn-sm btn-outline-danger px-3"
                                            onClick={() => {
                                              setSelectedId(
                                                item?.reimbursementForm?.id
                                              );
                                              toggle(item);
                                            }}
                                          // disabled={isOlderThan12Hours}
                                          >
                                            <DeleteIcon />
                                          </button>
                                        </>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              )}
                            </>
                          );
                        })
                    ) : (
                      <div className="d-flex flex-column justify-content-center align-items-center no-data-error">
                        <NoRecordIcon />
                        {"No record found"}
                      </div>
                    )}
                  </div>
                </Fade>
              </TabPane>
            </TabContent>

            <div className="d-flex justify-content-between align-items-center pt-3 mt-3 border-top">
              <div className="d-flex align-items-center gap-2">
                {filterDetails?.count > 0 && !pageStates?.tableLoader && (
                  <div className="dropdown short">
                    <button
                      className="btn dropdown-toggle border"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      {filterDetails?.pageSize}
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <path
                            d="M6.40039 8.19922L10.0004 11.7992L13.6004 8.19922"
                            stroke="#36394A"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                        </svg>
                      </span>
                    </button>
                    <ul className="dropdown-menu ">
                      {[10, 20, 30, 40, 50].map((value) => (
                        <li key={value}>
                          <button
                            className={`dropdown-item ${filterDetails?.pageSize === value && "active"
                              }`}
                            onClick={() => handleChangePageSize(value)}
                          >
                            {value}
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
                <div>
                  {filterDetails?.count > 0 && !pageStates?.tableLoader && (
                    <p
                      className="mb-0 text-muted fw-medium text-uppercase"
                      style={{ fontSize: "10px" }}
                    >
                      {`Showing ${filterDetails?.currentPage * filterDetails?.pageSize -
                        (filterDetails?.pageSize - 1)
                        } to ${filterDetails?.currentPage * filterDetails?.pageSize <
                          filterDetails?.count
                          ? filterDetails?.currentPage * filterDetails?.pageSize
                          : filterDetails?.count
                        } of ${filterDetails?.count} entries`}
                    </p>
                  )}
                </div>
              </div>

              <PaginationComponent
                currentPage={filterDetails?.currentPage}
                PageChangeHandler={PageChangeHandler}
                totalPages={filterDetails?.totalPages}
              />
            </div>
          </div>
        </div>
      </div>
      <ConfirmModal
        modal={model}
        toggle={toggle}
        submitHandler={HandleDelete}
        isLoading={isLoading}
      />
    </>
  );
}
